/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import EasySwipe from 'react-easy-swipe';
import { Modal, List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import { CloseIcon } from '@shared/assets/icons';
import genshinTooltip from '@shared/assets/images/cyber/genshinTooltip.jpg';
import genshinTooltipMobile from '@shared/assets/images/cyber/genshinTooltipMobile.jpg';
interface ModalBannerProps {
  open: boolean;
  handleClose: () => void;
}
export const GenshinTooltipMobile: FC<ModalBannerProps> = ({
  open,
  handleClose
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [swipeDirection, setSwipeDirection] = useState('');
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    setIsClosing(!open);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={handleCloseModal} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>Как&nbsp;найти свой UID в&nbsp;Genshin Impact?</Heading>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <WrapperList>
            <List data={[{
            id: 1,
            text: 'Откройте приложение Genshin Impact. Нажмите на\u00A0свой аватар в\u00A0левом верхнем углу главного экрана.'
          }, {
            id: 2,
            text: 'Во\u00A0вкладке «Профиль» вы увидите UID под аватаркой профиля'
          }]} size="md" sizemob="md" />
          </WrapperList>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <ImageWrapper>
            <Image src={genshinTooltip} width={536} height={140} alt="genshin" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapper>
          <ImageWrapperMobile>
            <Image src={genshinTooltipMobile} width={335} height={140} alt="genshin" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapperMobile>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
const _exp = /*#__PURE__*/() => Modal;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s1w9ggj8",
  propsAsIs: true,
  vars: {
    "s1w9ggj8-0": [_exp1()],
    "s1w9ggj8-1": [_exp3()],
    "s1w9ggj8-2": [_exp7(), "px"],
    "s1w9ggj8-3": [_exp5()],
    "s1w9ggj8-4": [_exp6(), "px"],
    "s1w9ggj8-5": [_exp8()],
    "s1w9ggj8-6": [_exp9()],
    "s1w9ggj8-7": [_exp0()]
  }
}));
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "wlirxfo",
  propsAsIs: false,
  vars: {
    "wlirxfo-0": [_exp10()]
  }
}));
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h1xst9n2",
  propsAsIs: false,
  vars: {
    "h1xst9n2-0": [_exp11()],
    "h1xst9n2-1": [_exp12(), "px"],
    "h1xst9n2-2": [_exp13()],
    "h1xst9n2-3": [_exp14(), "px"],
    "h1xst9n2-4": [_exp15()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "it3wwjo",
  propsAsIs: false
});
const ImageWrapperMobile = /*#__PURE__*/styled('div')({
  name: "ImageWrapperMobile",
  class: "i1a0paaw",
  propsAsIs: false
});

require("./GenshinTooltipMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./GenshinTooltipMobile.tsx");